type HtmlJnctEventName = Extract<keyof HTMLElementEventMap, `jnct:${string}`>;
type DocJnctEventName = Extract<keyof DocumentEventMap, `jnct:${string}`>;

type HtmlDispatchOptions<K extends HtmlJnctEventName> =
  HTMLElementEventMap[K] extends CustomEvent<infer P>
    ? { eventName: K; payload: P; target?: HTMLElement }
    : { eventName: K; payload?: never; target?: HTMLElement };

type DocDispatchOptions<K extends DocJnctEventName> =
  DocumentEventMap[K] extends CustomEvent<infer P>
    ? { eventName: K; payload: P; target: Document }
    : { eventName: K; payload?: never; target: Document };

export function dispatchJnctEvent<K extends HtmlJnctEventName>(
  options: HtmlDispatchOptions<K>
): void;
export function dispatchJnctEvent<K extends DocJnctEventName>(
  options: DocDispatchOptions<K>
): void;
export function dispatchJnctEvent({
  eventName,
  payload,
  target = document.documentElement,
}: {
  eventName: string;
  payload?: unknown;
  target?: EventTarget;
}): void {
  const event = payload !== undefined
    ? new CustomEvent(eventName, { detail: payload })
    : new Event(eventName);
  target.dispatchEvent(event);
}
